import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import Lineup from "../Lineup/Lineup";
import { DataContext } from "../../contexts/DataContext";
import { GraphicsContext } from "../../contexts/GraphicsContext";
import { VizContext } from "../../contexts/VizContext";
import { APIContext } from "../../contexts/APIContext";
import TeamStats from "../TeamStats/TeamStats";
import { UIContext } from "../../contexts/UIContext";
import useLocalStorage from "../../Hooks/useLocalStorage";

const Input = styled.input`
  background-color: #1f222b;
  border-radius: 4px;
  border: none;
  padding: 1em;
  margin-bottom: 1em;
  outline: none;
  color: #fff;
  width: 40px;
`;

const Buttons = styled.div`
  display: flex;
  width: 100%;
  padding: 0.5em;
  box-sizing: border-box;
      justify-content: space-around;
`;
const Main = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

const Title = styled.div`
  display: flex;
  border-bottom: 1px solid #dadde1;
  box-sizing: border-box;
  font-size: 1.5em;
  width: 100%;
  padding: 0.5em;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  background-color: white;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const ActionPanel = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 1em;
  /* padding: 1em; */
  align-items: center;
  box-sizing: border-box;
  justify-content: center;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  background-color: #181d25;
`;

const Lineups = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-evenly;
  height: 100%;
`;

const Centre = styled.div`
  display: flex;
  flex-direction: column;
  width: 20%;
  align-items: center;
  background-color: #0e1219;
`;

const SubsConfirm = styled.div`
  display: flex;
`;

const TeamSubs = styled.div`
  display: flex;
  width: 50%;
  flex-direction: column;
  align-items: center;
`;
const Button = styled.div`
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
  align-items: center;
  display: flex;
  background-color: ${(props) => (props.green ? "#0adb93" : "#db0a41")};
  color: ${(props) => (props.green ? "#1d1d1d" : "")};
  /* width: 100%; */
  justify-content: center;

  margin-top: 0.5em;
  padding: 0.5em;
`;
const Row = styled.div`
  display: flex;
`;
const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

const CentrePassButton = styled.div`
  font-size: 1em;
  padding: 0.5em;
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
  align-items: center;
  display: flex;
  background-color: ${(props) => (props.green ? "#0adb93" : "#181d25")};
  color: ${(props) => (props.green ? "#1d1d1d" : "")};
  /* width: 100%; */
  justify-content: center;
  margin: 0.2em;
  width: 25%;
  box-sizing: border-box;
  :hover {
    background-color: #db0a41;
  }
`;

export default function Game({
  game,
  setSelectedPlayer,
  selectedPlayer,
  goal,
  setGoal,
  optaLineup,
  countries,
  sky,
  isFruit,
  homeCoach,
  awayCoach,
}) {
  const { update } = useContext(DataContext);
  const { clear } = useContext(VizContext);
  const { updateGame } = useContext(APIContext);
  const { homeKit, awayKit, presToggle } = useContext(UIContext);
    const [amex, setAmex] = useLocalStorage(
    "netball-amex",
    0,
  );
    const {
    previewGraphic,
  } = useContext(GraphicsContext);
  return (
    <Main>
      {game && game.home_team && game.away_team && (
        <Content>
          <ActionPanel>
            <Lineups>
              {game && (
                <Lineup
                  presToggle={presToggle}
                  kit={homeKit}
                  manager={homeCoach}
                  isFruit={isFruit}
                  countries={countries}
                  optaLineup={optaLineup}
                  game={game}
                  kickedOff={true}
                  kickOffTime={game.actual_kick_off}
                  team={game.home_team}
                  lineup={game.lineup?.home || game.opta_lineup?.home}
                  player_stats={game.home_player_stats || []}
                  scorers={[
                    ...(game?.home_scorers || []),
                    ...(game?.away_scorers?.filter((g) => g.own_goal) || []),
                  ]}
                  selectedPlayer={selectedPlayer}
                  selectPlayer={(player) => {
                    if (goal) {
                      setSelectedPlayer({ ...player, team: game.home_team });
                      let own_goal = goal.team._id !== game.home_team._id;
                      let newScorers = [
                        ...(own_goal ? game.away_scorers : game.home_scorers),
                      ];
                      let index = newScorers.findIndex(
                        (g) => g._id === goal._id,
                      );
                      if (index > -1) {
                        setGoal();
                        let period =
                          game.live_data &&
                          game.live_data.periods &&
                          game.live_data.periods.sort(
                            (a, b) => b.number - a.number,
                          )[0];

                        newScorers[index] = {
                          ...newScorers[index],
                          player: player.squad._id,
                          time: goal.time,
                          own_goal: goal.team._id !== game.home_team._id,
                          penalty: goal.penalty,
                          period: period.number,
                        };

                        if (own_goal) {
                          updateGame({
                            id: game._id,
                            away_scorers: newScorers,
                          });
                        } else {
                          updateGame({
                            id: game._id,
                            home_scorers: newScorers,
                          });
                        }
                      }
                    } else {
                      if (player) {
                        setSelectedPlayer({ ...player, team: game.home_team });
                      } else {
                        setSelectedPlayer();
                      }
                    }
                  }}
                  removeGoal={(goal) => {
                    update({
                      type: "update_game",
                      _id: game._id,
                      variable: "live_data.home_scorers",
                      data: game.live_data.home_scorers.filter(
                        (s) => s.player !== goal.player || s.time !== goal.time,
                      ),
                    });
                    if (!goal.own_goal) {
                      update({
                        type: "update_game",
                        _id: game._id,
                        variable: "live_data.home_team_score",
                        data: game.live_data.home_team_score - 1,
                      });
                    } else {
                      update({
                        type: "update_game",
                        _id: game._id,
                        variable: "live_data.away_team_score",
                        data: game.live_data.away_team_score - 1,
                      });
                    }
                  }}
                />
              )}
              <Column style={{ width: "15%", marginTop: "37px" }}>
                <TeamStats game={game} />
              </Column>

              {game && (
                <Lineup
                  presToggle={presToggle}
                  kit={awayKit}
                  manager={awayCoach}
                  isFruit={isFruit}
                  countries={countries}
                  optaLineup={optaLineup}
                  game={game}
                  kickedOff={true}
                  kickOffTime={game.actual_kick_off}
                  team={game.away_team}
                  scorers={[
                    ...(game?.away_scorers || []),
                    ...(game?.home_scorers?.filter((g) => g.own_goal) || []),
                  ]}
                  lineup={game.lineup?.away || game.opta_lineup?.away}
                  player_stats={game.away_player_stats || []}
                  selectedPlayer={selectedPlayer}
                  selectPlayer={(player) => {
                    if (goal) {
                      setSelectedPlayer({ ...player, team: game.away_team });

                      let own_goal = goal.team._id !== game.away_team._id;
                      let newScorers = [
                        ...(own_goal ? game.home_scorers : game.away_scorers),
                      ];
                      let index = newScorers.findIndex(
                        (g) => g._id === goal._id,
                      );
                      if (index > -1) {
                        setGoal();
                        let period =
                          game.live_data &&
                          game.live_data.periods &&
                          game.live_data.periods.sort(
                            (a, b) => b.number - a.number,
                          )[0];

                        newScorers[index] = {
                          ...newScorers[index],
                          player: player.squad._id,
                          time: goal.time,
                          own_goal: goal.team._id !== game.away_team._id,
                          penalty: goal.penalty,
                          period: period.number,
                        };

                        if (own_goal) {
                          updateGame({
                            id: game._id,
                            home_scorers: newScorers,
                          });
                        } else {
                          updateGame({
                            id: game._id,
                            away_scorers: newScorers,
                          });
                        }
                      }
                    } else {
                      if (player) {
                        setSelectedPlayer({ ...player, team: game.away_team });
                      } else {
                        setSelectedPlayer();
                      }
                    }
                  }}
                  removeGoal={(goal) => {
                    update({
                      type: "update_game",
                      _id: game._id,
                      variable: "live_data.away_scorers",
                      data: game.live_data.away_scorers.filter(
                        (s) => s.player !== goal.player || s.time !== goal.time,
                      ),
                    });
                    if (!goal.own_goal) {
                      update({
                        type: "update_game",
                        _id: game._id,
                        variable: "live_data.away_team_score",
                        data: game.live_data.away_team_score - 1,
                      });
                    } else {
                      update({
                        type: "update_game",
                        _id: game._id,
                        variable: "live_data.home_team_score",
                        data: game.live_data.home_team_score - 1,
                      });
                    }
                  }}
                />
              )}
            </Lineups>
          </ActionPanel>
          <ScoresByQuarter game={game} />
           <Buttons>
            <div style={{display: "flex", width:"100%"}}>
          <CentrePassButton
            onClick={() => {
               previewGraphic("Amex", {
                  value: amex
                });
            }}
          >
            Amex
          </CentrePassButton>
          <Column>
            <Row>
              <Input
                value={amex}
                onChange={(e) => {
                  setAmex(e.currentTarget.value);
                }}
              />
            </Row>
          </Column>
         </div>
             <CentrePassButton
            onClick={() => {
               previewGraphic("Timeout", {
                  game, 
                  team: game?.home_team,
                  presToggle, 
                  kit: homeKit
                });
            }}
          >
            {game?.home_team?.name} Timeout
          </CentrePassButton>

             <CentrePassButton
            onClick={() => {
               previewGraphic("Timeout", {
                  game, 
                  team: game?.away_team,
                  presToggle, 
                  kit: awayKit
                });
            }}
          >
              {game?.away_team?.name} Timeout
          </CentrePassButton>
     
        </Buttons>
        </Content>
      )}
    </Main>
  );
}

const Table = styled.table`
  width: 100%;
  height: 10%;
  background-color: rgb(32, 39, 49);
  border-collapse: collapse;
  margin: 0.5em;
  th,
  td {
    border: 2px solid #181d25;
    padding-top: 5px;
    padding-left: 5px;
    padding-bottom: 5px;
    height: 44px;
  }
`;
const Scores = styled.td`
  text-align: center;
  min-width: 50px;
  padding-right: 5px;
  height: 44px;
`;
const Name = styled.td`
  padding-right: 10px;
  white-space: nowrap;
`;

function ScoresByQuarter({ game }) {
  return (
    <ActionPanel>
      <Column
        style={{ width: "50%", justifyContent: "center", alignItems: "center" }}
      >
        {/* <span style={{ opacity: 0.3 }}>Click player for season stats..</span> */}
      </Column>
      <Column style={{ width: "50%", height: "100%" }}>
        <Row>
          <Table>
            <thead>
              {game?.competition?.number_of_periods === 2 && (
                <tr>
                  <th></th>
                  <th>1st half</th>
                  <th>2nd half</th>
                  <th>ET</th>
                  <th>Goals</th>
                </tr>
              )}
              {game?.competition?.number_of_periods !== 2 && (
                <tr>
                  <th></th>
                  <th>Q1</th>
                  <th>Q2</th>
                  <th>Q3</th>
                  <th>Q4</th>
                  <th>ET</th>
                  <th>Goals</th>
                </tr>
              )}
            </thead>
            <tbody>
              <tr>
                <Name>{game?.home_team?.name}</Name>
                <Scores>
                  {parseInt(game?.scores_by_quarter?.home?.first) || 0}
                </Scores>
                <Scores>
                  {parseInt(game?.scores_by_quarter?.home?.second) || 0}
                </Scores>
                {game?.competition?.number_of_periods !== 2 && (
                  <Scores>
                    {parseInt(game?.scores_by_quarter?.home?.third) || 0}
                  </Scores>
                )}
                {game?.competition?.number_of_periods !== 2 && (
                  <Scores>
                    {parseInt(game?.scores_by_quarter?.home?.fourth) || 0}
                  </Scores>
                )}
                <Scores>
                  {parseInt(game?.scores_by_quarter?.home?.fith) || 0}
                </Scores>
                <Scores>{game?.scores_by_quarter?.home?.goals}</Scores>
              </tr>
              <tr>
                <Name>{game?.away_team?.name}</Name>
                <Scores>
                  {parseInt(game?.scores_by_quarter?.away?.first) || 0}
                </Scores>
                <Scores>
                  {parseInt(game?.scores_by_quarter?.away?.second) || 0}
                </Scores>
                {game?.competition?.number_of_periods !== 2 && (
                  <Scores>
                    {parseInt(game?.scores_by_quarter?.away?.third) || 0}
                  </Scores>
                )}
                {game?.competition?.number_of_periods !== 2 && (
                  <Scores>
                    {parseInt(game?.scores_by_quarter?.away?.fourth) || 0}
                  </Scores>
                )}
                <Scores>
                  {parseInt(game?.scores_by_quarter?.away?.fith) || 0}
                </Scores>
                <Scores>{game?.scores_by_quarter?.away?.goals}</Scores>
              </tr>
            </tbody>
          </Table>
        </Row>
      </Column>
      <Column
        style={{
          width: "50%",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {/* <span style={{ opacity: 0.3 }}>Click player for season stats..</span> */}
      </Column>
    </ActionPanel>
  );
}
